import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=74a281d9&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=74a281d9&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a281d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a281d9')) {
      api.createRecord('74a281d9', component.options)
    } else {
      api.reload('74a281d9', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=74a281d9&scoped=true", function () {
      api.rerender('74a281d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/pages/NotFound.vue"
export default component.exports